import { Component, OnInit, Input } from '@angular/core';
import { ReportISO } from '../../_objects/report-iso';
import { Notifier, ReportTemplateDesignService, MousePoint } from 'src/app/_services/report-template-design.service';
import { FromToDetail } from 'src/app/_objects/report-template';
import { ElementType } from 'src/app/_objects/element-type';

@Component({
    selector: 'app-report-iso',
    templateUrl: './report-iso.component.html',
    styleUrls: ['./report-iso.component.scss'],
    standalone: false
})
export class ReportIsoComponent implements OnInit {
  @Input() pageKey: string;
  @Input() isoKey: string;
  @Input() public elementLocation: string;

  reportIso: ReportISO;
  private notifier: Notifier;

  constructor(
    public designService: ReportTemplateDesignService
  ) {
  }

  ngOnInit() {
    this.notifier = {
      componentName: 'report-iso.component',
      ids: { pageId: this.pageKey, elementId: this.isoKey }
    };
    this.reportIso = this.designService.getInterActiveIso(this.isoKey);
    let elementNavigator = this.designService.navigatorElements
    .filter((x) => x.pageKey == this.pageKey)[0]
    .elementsDetails.filter((y) => y.location == this.elementLocation)[0]
      .elements;

     elementNavigator.filter(x=>x.elementName == ElementType.InteractiveIso).length > 0
      ? elementNavigator.filter(x=>x.elementName == ElementType.InteractiveIso)[0].elementData.push({
          id: this.isoKey,
          page: this.pageKey,
          name: this.reportIso.getTitle(),
        })
      : elementNavigator.push({
          elementName: ElementType.InteractiveIso,
          isVisible: false,
          elementData: [
            {
              id: this.isoKey,
              page: this.pageKey,
              name: this.reportIso.getTitle(),
            },
          ],
        });
  }

  onClick(event: MouseEvent) {
    if (this.reportIso.isSelectable) {
      this.designService.notifySelectElement(this.notifier, this.isoKey, event.ctrlKey);
      event.stopPropagation();
    }
  }

  onDragStart(event: DragEvent) {
    event.dataTransfer.setData('text', this.isoKey);
    event.dataTransfer.effectAllowed = 'move';

    const fromDetail: FromToDetail = {
      location: this.reportIso.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    this.designService.notifyBeginDrag(this.notifier, ElementType.InteractiveIso, fromDetail, dragPoint);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const template  = {...this.designService.originTemplate};
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    this.designService.templateForUndo.push(template);
    const dragElemId = event.dataTransfer.getData('text');

    const toDetail: FromToDetail = {
      location: this.reportIso.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportIso.getLeftPx() + event.offsetX,
      onElementY: this.reportIso.getTopPx() + event.offsetY
    };

    this.designService.notifyDrop(this.notifier, dragElemId, toDetail, dropPoint);

    event.dataTransfer.clearData('text');
    event.stopPropagation();
  }

}
